var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company"},[_c('Banner',{attrs:{"bannerContent":_vm.bannerContent}}),_c('HonorChunk',{attrs:{"id":"honor"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }